/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { LeadDiagnosis } from './LeadDiagnosis';
import {
    LeadDiagnosisFromJSON,
    LeadDiagnosisFromJSONTyped,
    LeadDiagnosisToJSON,
    LeadDiagnosisToJSONTyped,
} from './LeadDiagnosis';

/**
 * 
 * @export
 * @interface LeadDiagnoses
 */
export interface LeadDiagnoses {
    /**
     * Timestamp when ICD-10 extraction last completed for the lead
     */
    extracted_at: Date;
    /**
     * 
     */
    diagnoses: Array<LeadDiagnosis>;
}

/**
 * Check if a given object implements the LeadDiagnoses interface.
 */
export function instanceOfLeadDiagnoses(value: object): value is LeadDiagnoses {
    if (!('extracted_at' in value) || value['extracted_at'] === undefined) return false;
    if (!('diagnoses' in value) || value['diagnoses'] === undefined) return false;
    return true;
}

export function LeadDiagnosesFromJSON(json: any): LeadDiagnoses {
    return LeadDiagnosesFromJSONTyped(json, false);
}

export function LeadDiagnosesFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadDiagnoses {
    if (json == null) {
        return json;
    }
    return {
        
        'extracted_at': (json['extracted_at'] == null ? json['extracted_at'] : parseDateTime(json['extracted_at'])),
        'diagnoses': ((json['diagnoses'] as Array<any>).map(LeadDiagnosisFromJSON)),
    };
}

export function LeadDiagnosesToJSON(json: any): LeadDiagnoses {
    return LeadDiagnosesToJSONTyped(json, false);
}

export function LeadDiagnosesToJSONTyped(value?: LeadDiagnoses | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'extracted_at': value['extracted_at'] == null ? value['extracted_at'] : serializeDateTime(value['extracted_at']),
        'diagnoses': ((value['diagnoses'] as Array<any>).map(LeadDiagnosisToJSON)),
    };
}

